import { Button } from '@tryhackme/thm-ui-components';
import styled, { keyframes } from 'styled-components';

const linkSentKeyframes = keyframes`
  0% {
    -webkit-transform: translateX(100px);
    transform: translateX(100px);
      opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0px);
    transform: translateX(0px);
      opacity: 1;
  }
`;

const formKeyframes = keyframes`
    0% {
        -webkit-transform: translateX(0);
        transform: translateX(0);
        opacity: 1;
    }
    100% {
        -webkit-transform: translateX(-100px);
        transform: translateX(-100px);
        opacity: 0;
        display: none;
    }
`;

export const StyledMagicLoginCard = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 492px;
  width: 100%;

  background-color: ${({ theme }) => theme.colors.background.main};
  border-radius: ${({ theme }) => theme.radius.small};
  box-shadow: ${({ theme }) => theme.boxShadow.light};
  gap: 2.8rem;
  padding: 3.2rem;
  margin: 4.6rem auto;

  @media screen and (max-width: ${({ theme }) => theme.sizes.sm}) {
    padding: 1rem;
    margin: 1.8rem auto;
  }
`;

export const StyledMagicLoginForm = styled(StyledMagicLoginCard)<{ linkSent: boolean }>`
  animation-name: ${({ linkSent }) => (linkSent ? formKeyframes : '')};
  animation-duration: 0.3s;
  animation-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
  animation-fill-mode: forwards;
`;

export const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 2.8rem;
`;

export const StyledFullWidthButton = styled(Button)`
  width: 100%;
`;

export const StyledLinkSent = styled(StyledMagicLoginCard)<{ linkSent: boolean }>`
  opacity: 0;
  animation-name: ${({ linkSent }) => (linkSent ? linkSentKeyframes : '')};
  animation-duration: 0.3s;
  animation-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
  animation-fill-mode: forwards;
  animation-delay: 0.3s;
`;
